import axios from 'axios';

export const fetchAdsMetadata = (path, domain) => {
    const config = getConfig(domain);
    
    return axios({
        method: 'GET',
        url: `${config.adsMetadataUrl}?url=${path}&partnerId=${config.partnerId}`
    })
};

const getConfig = (domain) => {
    let config = {
        adsMetadataUrl: process.env.HL_ADS_METADATA_URL,
        partnerId: process.env.HL_ADS_METADATA_PARTNER_ID
    };

    if (domain?.includes('medicalnewstoday')) {
        config.adsMetadataUrl = process.env.MNT_ADS_METADATA_URL;
        config.partnerId = process.env.MNT_ADS_METADATA_PARTNER_ID;

    } else if (domain?.includes('greatist')) {
        config.adsMetadataUrl = process.env.GR8_ADS_METADATA_URL;
        config.partnerId = process.env.GR8_ADS_METADATA_PARTNER_ID;
    }

    return config;
}